module.exports = __webpack_public_path__ + "static/media/partner_liantong.b494acdc.png";